import styles from "./styles.module.scss";
import quoteData from "../../../.sourceflow/quote.json";

export const TestimonialList = ({ className = "", visibleCount = 3 }) => {
  const quotes = quoteData?.category_values?.slice(0, visibleCount) || [];

  return (
    <section className={`${styles.TestimonialList} ${className}`}>
      {quotes.map((item, idx) => {
        const quote = item?.quote?.en || "";
        const author = item?.author?.en || "";
        const role = item?.role?.en || "";
        const imageUrl = typeof item?.image === "string" ? item.image : item?.image?.en || "https://placehold.co/64x64";

        return (
          <div key={idx} className={styles.testimonialCard}>
            <div className={styles.quote}>”</div>
            <div className={`${styles.text}`} dangerouslySetInnerHTML={{ __html: quote }} />
            <div className={styles.profile}>
              <img className={styles.avatar} src={imageUrl} alt={author} />
              <div className={styles.info}>
                <div className={styles.name} dangerouslySetInnerHTML={{ __html: author }} />
                <div className={styles.role} dangerouslySetInnerHTML={{ __html: role }} />
              </div>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default TestimonialList;
